import { Component, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { AuthService } from '../../services/auth.service';
import { CommonModule, DatePipe } from '@angular/common';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import OktaAuth, { AuthState, AuthStateManager } from '@okta/okta-auth-js';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SignupuserService } from '../../services/signupuser.service';
import { ChangeDetectorRef } from '@angular/core';
import {
  ChangeDetectionStrategy,
  OnInit,
  inject,
  PLATFORM_ID,
} from "@angular/core";
import {
  FormArray,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";

import { isPlatformServer } from "@angular/common";

import {
  TuiButton,
  TuiIcon,
  TuiLabel,
  TuiLink,
  TuiTitle,
} from "@taiga-ui/core";
import {
  TuiProgressBar,
  TuiFieldErrorPipe,
  TuiCheckbox,
  TuiFilterByInputPipe,
  TuiFiles,
} from "@taiga-ui/kit";

import {
  TuiError,
  TuiDataList,
  TuiAppearance,
  TuiRoot,
  TuiTextfield,
  TuiDropdown,
} from "@taiga-ui/core";
import {
  TuiDataListWrapper,
  TuiRadio,
  TuiAvatar,
  TuiBadge,
  TuiItemsWithMore,
  TuiProgress,
  TuiBadgedContent,
  TuiTabs,
  TuiInputNumber,
} from "@taiga-ui/kit";

import {
  TuiInputDateModule,
  TuiInputModule,
  TuiInputPhoneModule,
  TuiInputSliderModule,
  TuiInputTimeModule,
  TuiSelectModule,
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputTagModule,
  TuiComboBoxModule,
  TuiMultiSelectModule,
  TuiInputDateTimeModule,
  TuiInputNumberModule,
} from "@taiga-ui/legacy";

import { TUI_IS_E2E, TuiDay } from "@taiga-ui/cdk";
import { AsyncPipe } from "@angular/common";
import { of, timer, takeWhile, share, repeat, map } from "rxjs";
import { NG_EVENT_PLUGINS } from "@taiga-ui/event-plugins";
import { ProgramService } from '../../services/program.service';
@Component({
  selector: 'app-program',
  standalone: true,
  imports: [ReactiveFormsModule,
    CommonModule,
    AsyncPipe,
    TuiProgressBar,
    TuiButton,
    TuiDropdown,
    TuiLabel,
    TuiFieldErrorPipe,
    TuiError,
    TuiDataList,
    TuiAppearance,
    TuiRadio,
    TuiInputDateModule,
    TuiTextfield,
    TuiTextfieldControllerModule,
    TuiInputModule,
    TuiInputNumber,
    TuiInputPhoneModule,
    TuiInputTimeModule,
    TuiSelectModule,
    TuiTextareaModule,
    TuiCheckbox,
    TuiAvatar,
    TuiInputTagModule,
    TuiIcon,
    TuiProgress,
    TuiFilterByInputPipe,
    TuiFiles,
    TuiComboBoxModule,
    TuiMultiSelectModule,
    TuiBadgedContent,
    TuiDataListWrapper,
    TuiInputNumberModule,
    TuiInputSliderModule,
    TuiTextfieldControllerModule,
    TuiItemsWithMore,
    TuiTabs,
    FormsModule,
    TuiTitle,
    TuiInputDateTimeModule,
    TuiLink,
    TuiRoot],
  templateUrl: './program.component.html',
  styleUrl: './program.component.css',
  providers: [NG_EVENT_PLUGINS,DatePipe],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgramComponent {
  programSchedule: any;
  applicationCheckinData: any;
  satisfactionsurveyData: any;
  cleanRowPhotos: any;
  endOfSeasonSurvey: any;
  applicationLockSatus: any;
  satisfactionSurveyStatus: any;
  endOfSeasonSurveyStatus: any;
  cleanRowPhotosStatus: any;
  programStatus: any;
  growerDetails: any;
  growerdata: any;
  constructor(private title: Title, private meta: Meta, private route: ActivatedRoute, private authService: AuthService, private signUpservice: SignupuserService, private cdr: ChangeDetectorRef,private datePipe:DatePipe,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth, private OktaAuthService: OktaAuthStateService, private router: Router, private spinner: NgxSpinnerService, private programService: ProgramService) {
    this.title.setTitle("Program | Storen Satisfaction Program");
    this.meta.updateTag({ name: 'description', content: 'Welcome to the Storen Satisfaction Program' })
  }
  code: any;
  error: any;
  userDetails: any;
  emailAddress: any;
  expirationDate: any;
  keepmeSignedIn: any;
  currentSurveyStep: number = 1;
  currentStep: number = 1;

  ngOnInit() {

    this.spinner.show();
    this.code = this.route.snapshot.queryParamMap.get('code');
    this.error = this.route.snapshot.queryParamMap.get('error');

    if (this.error == 'access_denied') {
      this.spinner.hide();
      let email = localStorage.getItem("email");
      this.signUpservice.loginvalidationmessage = "We're unable to find an active account with this email address " + "\"" + email + "\"" + ".   Please check if you've registered and activated your Storen Satisfaction Program account.";
      // this.sharedService.loginvalidationmessage = "This email address does not have access to this site.";
      this.router.navigate(['/log-in']);
    } else if ((this.code == '') || (this.code == null)) {
      this.emailAddress = localStorage.getItem("email");
      this.authService.checkAuthAndRedirect();
      this.signUpservice.loginvalidationmessage = "";
      this.spinner.hide();
      if(this.emailAddress !==null && this.emailAddress !=="" && this.emailAddress !=="undefined" && this.emailAddress !==undefined){
        this.getProgramSchedule();
      }

      // console.log("loginin yopmail", this.authService.checkAuthAndRedirect());
    }
    else if (this.code != '' && this.code != null && this.code != 'undefined') {
      this.signUpservice.loginvalidationmessage = "";
      this.emailAddress = localStorage.getItem("email");
      this.keepmeSignedIn = localStorage.getItem('keepmesigned');
      this.spinner.show();
      this.signUpservice.UpdateGrowersLastLogin(this.emailAddress).subscribe(res => {
        if (res.length > 2 && res !== "[]" && res !== '') {
          // console.log("User details" + res);
          this.userDetails = JSON.parse(res);
          this.signUpservice.setUserDetails(this.userDetails);
          if (this.userDetails[0].ACTIVE_IND > 0) {
            // console.log("Active Ind" + this.userDetails[0].ACTIVE_IND);
            let currentdate = new Date();
            if (this.keepmeSignedIn == "true") {
              const currentDate = new Date();
              currentDate.setDate(currentDate.getDate() + 30);
              let timeAfterHours = currentDate.toLocaleString('en-US', {
                timeZone: 'America/New_York',
                hour12: false,
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
              });
              this.expirationDate = timeAfterHours;
            } else {
              const currentDate = new Date();
              currentDate.setHours(currentDate.getHours() + 24);
              let timeAfterHours = currentDate.toLocaleString('en-US', {
                timeZone: 'America/New_York',
                hour12: false,
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
              });
              this.expirationDate = timeAfterHours;
            }
            //document.cookie = `loggedIn=true; expires=${expiryDate.toUTCString()}; path=/`;
            //document.cookie = `userName=${this.userDetails[0].USER_FIRST_NAME}; expires=${expiryDate.toUTCString()}; path=/`;
            //document.cookie = `userRole=${this.userDetails[0].JOB_TITLE}; expires=${expiryDate.toUTCString()}; path=/`;
            document.cookie = `userDetails=${JSON.stringify({ loggedIn: true, userName: this.userDetails[0].USER_FIRST_NAME + " " + this.userDetails[0].USER_LAST_NAME, userRole: this.userDetails[0].JOB_TITLE, email: this.emailAddress })}; expires=${this.expirationDate}; path=/`;
            let usdt = `userDetails=${JSON.stringify({ loggedIn: true, userName: this.userDetails[0].USER_FIRST_NAME + " " + this.userDetails[0].USER_LAST_NAME, userRole: this.userDetails[0].JOB_TITLE, email: this.emailAddress })}; expires=${this.expirationDate}; path=/`;
            this.signUpservice.updateDynamicText(usdt);
            this.authService.login();
            this.spinner.hide();
            this.router.navigate(['/program']);
            // this.getProgramSchedule();
            if(this.emailAddress !==null && this.emailAddress !=="" && this.emailAddress !=="undefined" && this.emailAddress !==undefined){
              this.getProgramSchedule();
            }


          } else {
            this.spinner.hide();
            this.signUpservice.loginvalidationmessage = "We're unable to find an active account with this email address " + "\"" + this.emailAddress + "\"" + ".   Please check if you've registered and activated your Storen Satisfaction Program account.";
            this.router.navigate(['/log-in']);

          }
        } else {
          this.spinner.hide();
          this.signUpservice.loginvalidationmessage = "We're unable to find an active account with this email address " + "\"" + this.emailAddress + "\"" + ".   Please check if you've registered and activated your Storen Satisfaction Program account.";
          this.router.navigate(['/log-in']);
        }
      });

    }

  }
  ngAfterViewInit() {
    this.cdr.detectChanges();
  }
  getProgramSchedule() {
    let todaysDate:any = this.datePipe.transform(new Date(),'YYYY-MM-dd')
    this.spinner.show();
    this.programService.getProgramSchedule().subscribe((schedule: any) => {
      this.programSchedule = schedule;
      if (this.programSchedule != "") {
        this.programSchedule = JSON.parse(this.programSchedule);
        this.programSchedule.forEach((data: any) => {
          if (data.Id == 1) {
            this.applicationCheckinData = data;
            let startDate:any = this.datePipe.transform(new Date(data.Start_Date),'YYYY-MM-dd');
            let endDate:any = this.datePipe.transform(new Date(data.End_Date),'YYYY-MM-dd');
            if (todaysDate < startDate) {
              this.applicationLockSatus = 'LOCK';
            } else if (todaysDate > endDate) {
              this.applicationLockSatus = 'GETSTARTEDDISABLE';
            } else if (todaysDate >= startDate && todaysDate <= endDate) {
              this.applicationLockSatus = 'GETSTARTED';
            }

          } else if (data.Id == 2) {
            this.satisfactionsurveyData = data;
            let startDate:any = this.datePipe.transform(new Date(data.Start_Date),'YYYY-MM-dd');
            let endDate:any = this.datePipe.transform(new Date(data.End_Date),'YYYY-MM-dd');
            if (todaysDate < startDate) {
              this.satisfactionSurveyStatus = 'LOCK';
            } else if (todaysDate > endDate) {
              this.satisfactionSurveyStatus = 'GETSTARTEDDISABLE';
            } else if (todaysDate >= startDate && todaysDate <= endDate) {
              this.satisfactionSurveyStatus = 'GETSTARTED';
            }
          } else if (data.Id == 3) {
            this.cleanRowPhotos = data;
            let startDate:any = this.datePipe.transform(new Date(data.Start_Date),'YYYY-MM-dd');
            let endDate:any = this.datePipe.transform(new Date(data.End_Date),'YYYY-MM-dd');
            if (todaysDate < startDate || this.satisfactionSurveyStatus !== 'COMPLETED') {
              this.cleanRowPhotosStatus = 'LOCK';
            } else if (todaysDate > endDate) {
              this.cleanRowPhotosStatus = 'GETSTARTEDDISABLE';
            } else if (todaysDate >= startDate && todaysDate <= endDate) {
              this.cleanRowPhotosStatus = 'GETSTARTED';
            }
          } else if (data.Id == 4) {
            this.endOfSeasonSurvey = data;
            let startDate:any = this.datePipe.transform(new Date(data.Start_Date),'YYYY-MM-dd');
            let endDate:any = this.datePipe.transform(new Date(data.End_Date),'YYYY-MM-dd');
            if (todaysDate < startDate) {
              this.endOfSeasonSurveyStatus = 'LOCK';
            } else if (todaysDate > endDate) {
              this.endOfSeasonSurveyStatus = 'GETSTARTEDDISABLE';
            } else if (todaysDate >= startDate && todaysDate <= endDate) {
              this.endOfSeasonSurveyStatus = 'GETSTARTED';
            }
          }
        })
        this.spinner.hide();
      }
      this.getGrowerDetails();
    },(error)=>{
      this.spinner.hide();
    })
  }
  getGrowerDetails() {
    this.spinner.show();
    this.programService.getgrowerdetailsbyEmailId(this.emailAddress).subscribe((res: any) => {
      this.growerDetails = JSON.parse(res);
     //localStorage.setItem("growerDetails", JSON.stringify(this.growerDetails));
      //this.programService.setGrowerDetails(this.growerDetails);
      if (this.growerDetails.length > 0) {
        this.growerdata = this.growerDetails[0].GROWER_ID;
        this.getProgramStatus();
      }
    })
  }
  getProgramStatus() {
    this.spinner.show();
    let todaysDate:any = this.datePipe.transform(new Date(),'YYYY-MM-dd')
    this.programService.getProgramStatus(this.growerdata).subscribe((res: any) => {
      this.programStatus = res;
      if (this.programStatus !== "" && this.programStatus.length > 0) {
        this.programStatus = JSON.parse(res);
        //localStorage.setItem("trailId",this.programStatus[0].trail_id);
        //  this.programService.setTrialId(this.programStatus[0].trail_id);

        this.programSchedule.forEach((data: any) => {
          this.programStatus.forEach((value: any) => {
            if (data.Id == 1 && value.program_schedule_Id == data.Id) {
              this.applicationLockSatus = 'COMPLETED';
            } else if (data.Id == 2 && value.program_schedule_Id == data.Id) {
              this.satisfactionSurveyStatus = 'COMPLETED';
            } else if (data.Id == 3 && value.program_schedule_Id == data.Id) {
              this.cleanRowPhotosStatus = 'COMPLETED';
            } else if (data.Id == 4 && value.program_schedule_Id == data.Id) {
              this.endOfSeasonSurveyStatus = 'COMPLETED';
            }
          })
          //  if (data.Id == 2 && this.applicationLockSatus=='COMPLETED' && this.satisfactionSurveyStatus!=='COMPLETED') {
          //   this.satisfactionsurveyData = data;
          //   let startDate:any = this.datePipe.transform(new Date(data.Start_Date),'YYYY-MM-dd');
          //   let endDate:any = this.datePipe.transform(new Date(data.End_Date),'YYYY-MM-dd');
          //   if (todaysDate < startDate) {
          //     this.satisfactionSurveyStatus = 'LOCK';
          //   } else if (todaysDate > endDate) {
          //     this.satisfactionSurveyStatus = 'GETSTARTEDDISABLE';
          //   } else if (todaysDate >= startDate && todaysDate <= endDate) {
          //     this.satisfactionSurveyStatus = 'GETSTARTED';
          //   }
           if (data.Id == 3 && this.satisfactionSurveyStatus =='COMPLETED' && this.cleanRowPhotosStatus!=='COMPLETED') {
            this.cleanRowPhotos = data;
            let startDate:any = this.datePipe.transform(new Date(data.Start_Date),'YYYY-MM-dd');
            let endDate:any = this.datePipe.transform(new Date(data.End_Date),'YYYY-MM-dd');
            if (todaysDate < startDate) {
              this.cleanRowPhotosStatus = 'LOCK';
            } else if (todaysDate > endDate) {
              this.cleanRowPhotosStatus = 'GETSTARTEDDISABLE';
            } else if (todaysDate >= startDate && todaysDate <= endDate) {
              this.cleanRowPhotosStatus = 'GETSTARTED';
            }
          } 
          // else if (data.Id == 4 && this.cleanRowPhotosStatus=='COMPLETED' && this.endOfSeasonSurveyStatus!='COMPLETED') {
          //   this.endOfSeasonSurvey = data;
          //   let startDate:any = this.datePipe.transform(new Date(data.Start_Date),'YYYY-MM-dd');
          //   let endDate:any = this.datePipe.transform(new Date(data.End_Date),'YYYY-MM-dd');
          //   if (todaysDate < startDate) {
          //     this.endOfSeasonSurveyStatus = 'LOCK';
          //   } else if (todaysDate > endDate) {
          //     this.endOfSeasonSurveyStatus = 'GETSTARTEDDISABLE';
          //   } else if (todaysDate >= startDate && todaysDate <= endDate) {
          //     this.endOfSeasonSurveyStatus = 'GETSTARTED';
          //   }
          // }
        })
      }
      // localStorage.setItem("applicationLockSatus",this.applicationLockSatus);
      // localStorage.setItem("satisfactionSurveyStatus",this.satisfactionSurveyStatus);
      // localStorage.setItem("cleanRowPhotosStatus",this.cleanRowPhotosStatus);
      // localStorage.setItem("endOfSeasonSurveyStatus",this.endOfSeasonSurveyStatus);
      sessionStorage.setItem("applicationLockSatus", this.applicationLockSatus);
      sessionStorage.setItem("satisfactionSurveyStatus", this.satisfactionSurveyStatus);
      sessionStorage.setItem("cleanRowPhotosStatus", this.cleanRowPhotosStatus);
      sessionStorage.setItem("endOfSeasonSurveyStatus", this.endOfSeasonSurveyStatus);

      this.spinner.hide();
    })
    //})

  }
  downloadImage(imageUrl: string, imageName: string) {
    window.open(imageUrl,"_blank");
    // fetch(imageUrl)
    //   .then((response) => response.blob())
    //   .then((blob) => {
    //     const url = URL.createObjectURL(blob);
    //     const a = document.createElement("a");
    //     a.href = url;
    //     a.download = imageName;
    //     a.click();
    //     URL.revokeObjectURL(url);
    //   })
    //   .catch((error) => console.error("Error downloading image:", error));
  }
  getStarted(step: any) {
    this.currentStep = step;
    this.currentSurveyStep = step;
    if (step == 2) {
      this.router.navigate(['/application-checkin']).then(()=>{  
        window.scrollTo({top:0,behavior:'smooth'});
      });     
    } else if (step == 3) {
      this.router.navigate(['/satisfaction-survey']).then(()=>{
       window.scrollTo({top:0,behavior:'smooth'});
      });
      this.router.navigate(['/satisfaction-survey']);
    } else if (step == 4) {
      this.router.navigate(['/clean-row-photos']).then(()=>{
       window.scrollTo({top:0,behavior:'smooth'})
      });
      this.router.navigate(['/clean-row-photos']);
    } else if (step == 5) {
      this.router.navigate(['/end-of-season-survey']).then(()=>{
        window.scrollTo({top:0,behavior:'smooth'});
      });
      
    }

  }


}
